import { ORDER_DETAIL_RESPONSE } from './actions'

const initialState = {
  isLoading: false,
  order: null,
  loaded: false,
}

export default function warranty(state = initialState, action) {
  switch (action.type) {
    case ORDER_DETAIL_RESPONSE:
      return Object.assign({}, state, {
        order: action.order,
      })
    default:
      return state
  }
}
